<script>
    export default {
        inject: ['EventBus', 'PIXIWrapper'],
        // x, y define the sprite's position in the parent.
        // value is the path to the image on the server to render as the sprite.
        props: ['x', 'y', 'anchor', 'value'],

        data() {
            return {
                sprite: null
            }
        },

        render(h) { return h() },

        created() {
            this.sprite = this.PIXIWrapper.PIXI.Sprite.from(this.value);
            // Set the initial position.
            this.sprite.x = this.x || 0;
            this.sprite.y = this.y || 0;
            this.sprite.anchor.set(this.anchor || 0);

            // Opt-in to interactivity.
            this.sprite.interactive = true;

            // When the PIXI renderer starts.
            this.EventBus.$on('ready', () => {
                // Add the sprite to the parent container or the root app stage.
                if (this.$parent.container) {
                    this.$parent.container.addChild(this.sprite);
                } else {
                    this.PIXIWrapper.PIXIApp.stage.addChild(this.sprite);
                }

                let scale = this.$parent.$parent.$refs.renderCanvas.offsetWidth / 655;
                this.sprite.x *= scale;
                this.sprite.y *= scale;
                this.sprite.scale.x = this.sprite.scale.y = scale;
            });
        }
    }
</script>
